import { render, staticRenderFns } from "./ProjectListView.vue?vue&type=template&id=0ecf7c42&"
import script from "./ProjectListView.vue?vue&type=script&lang=js&"
export * from "./ProjectListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports